import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-92b6a540"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-success alert-dismissible fade show",
  role: "alert"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle me-1" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-10" }, "Chargement des questions...", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "results-container"
}
const _hoisted_10 = { class: "" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-20" }, "Test Terminé !", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "row gx-2" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Score", -1))
const _hoisted_18 = { class: "fs-1 fw-bold text-success" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Pourcentage", -1))
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Bonnes réponses", -1))
const _hoisted_25 = { class: "fs-1 fw-bold text-success" }
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Mauvaises réponses", -1))
const _hoisted_29 = { class: "fs-1 fw-bold text-danger" }
const _hoisted_30 = { class: "text-start mt-10" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-15 text-center" }, "📋 Revue détaillée de vos réponses", -1))
const _hoisted_32 = { class: "questions-review" }
const _hoisted_33 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_34 = { class: "mb-0 fw-bold" }
const _hoisted_35 = { class: "question-number" }
const _hoisted_36 = { class: "question-content p-10 bg-white" }
const _hoisted_37 = { class: "fw-semibold mb-10 text-black" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-black" }, "Votre réponse :", -1))
const _hoisted_39 = {
  key: 0,
  class: "correct-answer-display p-10 bg-success-subtle rounded"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-blue" }, "✓ Bonne réponse :", -1))
const _hoisted_41 = { class: "ms-2 text-blue fw-bold" }
const _hoisted_42 = {
  class: "progress mb-20",
  style: {"height":"8px"}
}
const _hoisted_43 = {
  key: 0,
  class: "form-group mb-10"
}
const _hoisted_44 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_45 = { class: "alert alert-info" }
const _hoisted_46 = {
  key: 1,
  class: "form-group mb-10"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sélectionner une réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_48 = {
  key: 0,
  class: "border border-primary p-10"
}
const _hoisted_49 = { class: "d-flex align-items-center mb-5" }
const _hoisted_50 = ["for"]
const _hoisted_51 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_52 = {
  key: 2,
  class: "form-group mb-10"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Votre réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_54 = {
  key: 3,
  class: "form-group mb-10"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sélectionner une réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_56 = { class: "border border-primary p-10" }
const _hoisted_57 = { class: "d-flex align-items-center mb-5" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-black",
  for: "oui",
  style: {"cursor":"pointer"}
}, "Oui", -1))
const _hoisted_59 = { class: "d-flex align-items-center mb-5" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-black",
  for: "non",
  style: {"cursor":"pointer"}
}, "Non", -1))
const _hoisted_61 = { class: "d-flex align-items-center mt-10" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_65 = {
  key: 4,
  class: "mt-10"
}
const _hoisted_66 = { class: "text-danger" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  key: 5,
  class: "mt-10"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-success" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle me-1" }),
  /*#__PURE__*/_createTextVNode(" Prêt à continuer ")
], -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = {
  key: 4,
  class: "text-danger text-center"
}
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"alert alert-danger\" data-v-92b6a540><h4 data-v-92b6a540>Test impossible à générer</h4><p class=\"mb-10\" data-v-92b6a540> Le test ne peut pas être généré car il nécessite exactement <strong data-v-92b6a540>20 questions</strong> pour être valide. </p><div class=\"alert alert-warning text-start\" data-v-92b6a540><strong data-v-92b6a540>Causes possibles :</strong><ul class=\"mb-0\" data-v-92b6a540><li data-v-92b6a540>Moins de 20 questions disponibles pour les critères sélectionnés (niveau, matière, filière)</li><li data-v-92b6a540>Questions invalides (sans propositions ou sans bonnes réponses)</li><li data-v-92b6a540>Paramètres de niveau, matière ou filière incorrects</li><li data-v-92b6a540>Problème de connexion à l&#39;API</li></ul></div><div class=\"alert alert-info text-start mt-10\" data-v-92b6a540><strong data-v-92b6a540>Solutions :</strong><ul class=\"mb-0\" data-v-92b6a540><li data-v-92b6a540>Vérifiez qu&#39;il y a au moins 20 questions valides dans la base de données</li><li data-v-92b6a540>Ajoutez des questions pour cette combinaison niveau/matière/filière</li><li data-v-92b6a540>Modifiez les critères de sélection</li></ul></div></div>", 1)
const _hoisted_73 = { class: "d-flex justify-content-center gap-2" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-list me-1" }, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.confirmationMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.confirmationMessage) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmationMessage = null)),
              "aria-label": "Close"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : (_ctx.showResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    (_ctx.sessionId)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Session ID: " + _toDisplayString(_ctx.sessionId), 1))
                      : _createCommentVNode("", true),
                    (_ctx.sessionCode)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Code de la session: " + _toDisplayString(_ctx.sessionCode), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.testResults.score) + " / " + _toDisplayString(_ctx.testResults.total), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("p", {
                        class: _normalizeClass(["fs-1 fw-bold", _ctx.testResults.percentage >= 50 ? 'text-success' : 'text-danger'])
                      }, _toDisplayString(_ctx.testResults.percentage) + "% ", 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.testResults.correctAnswers), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.testResults.incorrectAnswers), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionsWithAnswers, (question, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: question.id,
                        class: _normalizeClass(["question-review-item mb-15 border", question.isCorrect ? 'border-success' : 'border-danger'])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["question-header p-5", question.isCorrect ? 'bg-success-subtle' : 'bg-danger-subtle'])
                        }, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("h5", _hoisted_34, [
                              _createElementVNode("span", _hoisted_35, "Question " + _toDisplayString(index + 1), 1)
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass(["fs-3", question.isCorrect ? 'text-success' : 'text-danger'])
                            }, _toDisplayString(question.isCorrect ? '✓' : '✗'), 3)
                          ])
                        ], 2),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("p", _hoisted_37, _toDisplayString(question.contenu), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["user-answer mb-5 p-10 rounded", question.isCorrect ? 'bg-light' : 'bg-light'])
                          }, [
                            _hoisted_38,
                            _createElementVNode("span", {
                              class: _normalizeClass(["ms-2 fw-semibold", question.isCorrect ? 'text-success' : 'text-danger text-decoration-line-through'])
                            }, _toDisplayString(question.userAnswerText), 3)
                          ], 2),
                          (!question.isCorrect)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _hoisted_40,
                                _createElementVNode("span", _hoisted_41, _toDisplayString(question.correctAnswerText), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_ctx.questions.length > 0)
            ? (_openBlock(), _createBlock(_component_Form, {
                key: 3,
                ref: "testForm",
                onSubmit: _ctx.handleSubmit,
                "validation-schema": _ctx.testSchema
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", {
                      class: "progress-bar bg-success",
                      style: _normalizeStyle({ width: _ctx.progressPercentage + '%' })
                    }, null, 4)
                  ]),
                  (_ctx.currentQuestion)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("label", _hoisted_44, " Question " + _toDisplayString(_ctx.currentQuestionIndex + 1) + " / " + _toDisplayString(_ctx.questions.length), 1),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.currentQuestion.contenu), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentQuestion && _ctx.currentQuestion.type === 'choix_multiple')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _hoisted_47,
                        (_ctx.propositionOptions.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propositionOptions, (proposition, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `prop-${proposition.value}-${index}`
                                }, [
                                  _createElementVNode("div", _hoisted_49, [
                                    _createVNode(_component_Field, {
                                      name: "answer",
                                      type: "radio",
                                      value: proposition.value,
                                      modelValue: _ctx.formData.answer,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.answer) = $event)),
                                      id: `proposition-${proposition.value}`,
                                      class: "form-check-input me-2",
                                      onChange: _ctx.onAnswerChange
                                    }, null, 8, ["value", "modelValue", "id", "onChange"]),
                                    _createElementVNode("label", {
                                      class: "text-black",
                                      for: `proposition-${proposition.value}`,
                                      style: {"cursor":"pointer"}
                                    }, _toDisplayString(proposition.label), 9, _hoisted_50)
                                  ])
                                ]))
                              }), 128)),
                              _createVNode(_component_ErrorMessage, {
                                name: "answer",
                                class: "text-danger"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_51, " Aucune proposition disponible pour cette question. "))
                      ]))
                    : (_ctx.currentQuestion && _ctx.currentQuestion.type === 'texte_libre')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _hoisted_53,
                          _createVNode(_component_Field, {
                            name: "answer",
                            as: "textarea",
                            class: "form-control shadow-none text-black",
                            modelValue: _ctx.formData.answer,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.answer) = $event)),
                            placeholder: "Entrez votre réponse",
                            rows: "4",
                            onInput: _ctx.onAnswerChange
                          }, null, 8, ["modelValue", "onInput"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "answer",
                            class: "text-danger"
                          })
                        ]))
                      : (_ctx.currentQuestion && _ctx.currentQuestion.type === 'oui_non')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _hoisted_55,
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createVNode(_component_Field, {
                                  name: "answer",
                                  type: "radio",
                                  value: "Oui",
                                  modelValue: _ctx.formData.answer,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.answer) = $event)),
                                  id: "oui",
                                  class: "form-check-input me-2",
                                  onChange: _ctx.onAnswerChange
                                }, null, 8, ["modelValue", "onChange"]),
                                _hoisted_58
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                _createVNode(_component_Field, {
                                  name: "answer",
                                  type: "radio",
                                  value: "Non",
                                  modelValue: _ctx.formData.answer,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.answer) = $event)),
                                  id: "non",
                                  class: "form-check-input me-2",
                                  onChange: _ctx.onAnswerChange
                                }, null, 8, ["modelValue", "onChange"]),
                                _hoisted_60
                              ]),
                              _createVNode(_component_ErrorMessage, {
                                name: "answer",
                                class: "text-danger"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-secondary me-3", { 'cursor-not-allowed': _ctx.currentQuestionIndex === 0 }]),
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.previousQuestion && _ctx.previousQuestion(...args))),
                      disabled: _ctx.currentQuestionIndex === 0
                    }, " Précédent ", 10, _hoisted_62),
                    _createElementVNode("button", {
                      type: "submit",
                      class: _normalizeClass(["btn", [
              _ctx.isLastQuestion ? 'btn-success' : 'btn-info',
              { 'cursor-not-allowed': _ctx.isDisable }
            ]]),
                      disabled: _ctx.isDisable || _ctx.isSubmitting
                    }, [
                      (_ctx.isSubmitting)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64))
                        : (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            class: _normalizeClass(_ctx.isLastQuestion ? 'fa fa-check me-1' : 'fa fa-arrow-right me-1')
                          }, null, 2)),
                      _createTextVNode(" " + _toDisplayString(_ctx.isLastQuestion ? 'Terminer le test' : 'Suivant'), 1)
                    ], 10, _hoisted_63)
                  ]),
                  (_ctx.isDisable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("small", _hoisted_66, [
                          (!_ctx.currentQuestion)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_67, "Aucune question disponible"))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_70))
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                _hoisted_72,
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(_component_router_link, {
                    to: "/liste-questions",
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_74,
                      _createTextVNode(" Voir les questions ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/add-question",
                    class: "btn btn-success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_75,
                      _createTextVNode(" Ajouter des questions ")
                    ]),
                    _: 1
                  })
                ])
              ]))
    ])
  ]))
}